import { hasAvailableAction } from '../../../../ui/gov-actions'

export const errorStatus = (status) =>
  status &&
  ['cancelled', 'rejected', 'no longer at risk'].includes(
    status.toLocaleLowerCase()
  )
export const warningStatus = (status) =>
  status && ['ineffective', 'revocation', 'pending'].includes(status.toLocaleLowerCase())
export const okStatus = (status) =>
  status && ['approved'].includes(status.toLocaleLowerCase())
export const available = (record) =>
  hasAvailableAction(record, ['create_certificate', 'create_determination'])



// WEBPACK FOOTER //
// ./src/care-enrolments/details/accs-gov-enrolments/view/helper.js